import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useTwinPersona } from "./Address";

function Pill({className, children}) {
  return <div className={["py-1 ~px-1 rounded-full border border-gray-400", className].join(" ")}>
    {children}
  </div>
}

function personaText(p) {
  if (p.name) {
    if (p.email) {
      return `${p.name} (${p.email})`
    } else {
      return p.email
    }
  } else if (p.email) {
    return p.email;
  } else {
    return null;
  }
}

export function TwinPersona({ twinUrl }) {

  const { info, persona } = useTwinPersona(twinUrl)

  if (info.isPending) {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0 text-disabled">
      <span className="select-none" title="Testing twin reachability">⏳</span> {twinUrl}
    </div>
  } else if (info.isError) {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0 text-error">
      <span className="select-none" title="Twin URL unreachable">❌</span> {twinUrl}
    </div>
  } else if (persona.data && (persona.data.name || persona.data.email)) {
    return <Pill className="overflow-hidden overflow-ellipsis w-full">
      <div className="px-1 flex flex-row items-center w-full ">
        <div className="flex rounded-full size-10 aspect aspect-square text-xl font-semibold bg-gray-400 text-white items-center justify-center">
          <p className="overflow-hidden overflow-ellipsis">{ personaText(persona.data).slice(0,2).toUpperCase() }</p>
        </div>
        <div className="w-full flex flex-col ml-2 rounded-r-full overflow-hidden">
          <div className="w-full">{personaText(persona.data)}</div>
          <div className="w-full text-[0.70rem] text-gray-400 text-nowrap overflow-hidden overflow-ellipsis">{twinUrl}</div>
        </div>
      </div>
    </Pill>
  } else {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0">
      <span className="select-none" title="Twin URL reachable (no persona info available)">✅</span> {twinUrl}
    </div>
  }
}

export function TwinPersona1({ twinUrl, info, persona }) { // I know; will fix in the new year

  if (info.isPending) {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0 text-disabled">
      <span className="select-none" title="Testing twin reachability">⏳</span> {twinUrl}
    </div>
  } else if (info.isError) {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0 text-error">
      <span className="select-none" title="Twin URL unreachable">❌</span> {twinUrl}
    </div>
  } else if (persona.data && (persona.data.name || persona.data.email)) {
    return <Pill className="overflow-hidden overflow-ellipsis w-full">
      <div className="px-1 flex flex-row items-center w-full ">
        <div className="flex rounded-full size-10 aspect aspect-square text-xl font-semibold bg-gray-400 text-white items-center justify-center">
          <p className="overflow-hidden overflow-ellipsis">{ personaText(persona.data).slice(0,2).toUpperCase() }</p>
        </div>
        <div className="w-full flex flex-col ml-2 rounded-r-full overflow-hidden">
          <div className="w-full">{personaText(persona.data)}</div>
          <div className="w-full text-[0.70rem] text-gray-400 text-nowrap overflow-hidden overflow-ellipsis">{twinUrl}</div>
        </div>
      </div>
    </Pill>
  } else {
    return <div className="text-nowrap overflow-hidden overflow-ellipsis min-w-0">
      <span className="select-none" title="Twin URL reachable (no persona info available)">✅</span> {twinUrl}
    </div>
  }
}